import { render, staticRenderFns } from "./MenuSubclassComp.vue?vue&type=template&id=51cf457e&scoped=true&"
import script from "./MenuSubclassComp.vue?vue&type=script&lang=ts&"
export * from "./MenuSubclassComp.vue?vue&type=script&lang=ts&"
import style0 from "./MenuSubclassComp.vue?vue&type=style&index=0&id=51cf457e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51cf457e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VContainer,VFlex,VLayout,VTooltip})
